import { gql } from "@apollo/client";

export const UPDATE_APPOINTMENT_RATING = gql`
  mutation updateAppointmentRating($data: RatingRequestInput!){
  updateAppointmentRating(updateRatingData: $data){
    success,
    messages,
    appointmentPlaceId
  }
}
`;

